import { request } from "@/axios";
import { WatermarkStatusEnum } from "@/types/alipayRealName";

// 获取用户信息
export function queryUserInfo<T>() {
  return request<Partial<T>>({
    api: "/api/user/userInfo",
    method: "post",
    notToast: false,
    data: {}
  });
}

/**
 * 更新用户协议/水印状态
 * 
 * 接口地址: POST /api/user/updateRealizeResult/status
 * 直接传递目标状态值(0-5)，后端负责校验和更新 realizeResult
 * 
 * @param status 目标状态值（见 WatermarkStatusEnum）
 *   - 4 = 已签署(水印ON) — 同意协议后的默认状态
 *   - 5 = 已签署(水印OFF) — 关闭水印
 */
export function updateWatermarkStatus(status: WatermarkStatusEnum) {
  return request<{ realizeResult?: number }>({
    api: "/api/user/updateRealizeResult/status",
    method: "post",
    notToast: false,
    data: { status }
  });
}
